import Table from 'react-bootstrap/Table';
import {Button, Stack} from "react-bootstrap";
import useTranslation from "../hooks/translations";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function SimpleDataTable({
                                    columns,
                                    rows,
                                    editAction,
                                    deleteAction
                                  }) {
  const translations = useTranslation();
  return (
    <div className="datatable-wrapper">
      <div className="datatable-container">
        <Table responsive bordered striped>
          <thead>
          <tr>
            {
              columns.map((column, index) => (
                  <th key={index}>{column.name}</th>
                )
              )
            }
            {
              (editAction || deleteAction) &&
              <th>{translations.actions}</th>
            }
          </tr>
          </thead>
          <tbody>
          {
            rows.map((row, _) => (
                <tr key={row.id}>
                  {columns.map((column, index) => (
                    <td key={index}>{row[column.data_identifier]}</td>
                  ))}
                  {(editAction || deleteAction) &&
                    <td>
                      <Stack direction="horizontal" gap={3}>
                        {
                          editAction &&
                          <Button variant="primary"
                                  size="sm"
                                  onClick={() => {
                                    editAction(row);
                                  }
                                  }>
                            <FontAwesomeIcon icon="edit" className="me-1" />
                            {translations.edit}
                          </Button>
                        }
                        {
                          deleteAction &&
                          <Button variant="danger"
                                  size="sm"
                                  onClick={() => {
                                    deleteAction(row);
                                  }}>
                            <FontAwesomeIcon icon="trash" className="me-1" />
                            {translations.delete}
                          </Button>
                        }
                      </Stack>
                    </td>}
                </tr>
              )
            )
          }
          </tbody>
        </Table>
      </div>
    </div>
  )
}
